import { render, staticRenderFns } from "./ResourceConfiguration.vue?vue&type=template&id=57b23862&scoped=true&"
import script from "./ResourceConfiguration.vue?vue&type=script&lang=js&"
export * from "./ResourceConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./ResourceConfiguration.vue?vue&type=style&index=0&id=57b23862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b23862",
  null
  
)

export default component.exports